import { createBrowserRouter, Navigate } from "react-router-dom";
import WithHeaderLayout from "../components/WithHeaderLayout";
import WithoutHeaderLayout from "../components/WithoutHeaderLayout";

import HomeComponent from "../components/HomeComponent";
import DocumentView from "../pages/DocumentView";
import Login from "../pages/Login";
import UploadDocuments from "../pages/UploadDocuments";
import AI_PDF_CONST from "../util/PdfAiConst";
import PrivateRoute from "../util/PrivateRoute";
import Holios from "../pages/Holios";
import HoliosUploadData from "../pages/HoliosUploadData";
import AIAutomation from "../pages/AIAutomation";
import AiLanding from "../pages/AiLanding";
import AIAutomationOptionA from "../pages/AIAutomationOptionA";
import AIAutomationOptionB from "../pages/AIAutomationOptionB";
import AIAutomation2 from "../pages/AIAutomation2";
import Communication from "../pages/Communication";
import AiComm from "../pages/AiComm";
import PdfToExl from "../pages/PdfToExl";
import VoiceCall from "../pages/VoiceCall";
import AdminOrgsPage from "../pages/AdminOrgsPage";
import AdminOrgUsersPage from "../pages/AdminOrgUsersPage";
import HomeComponent2 from "../components/HomeComponent2";
import Chat from "../pages/Chat";
import CentralWhatsAppInbox from "../pages/admin/CentralWhatsAppInbox";
import AdminDashboardPage from "../pages/admin/Dashboardpage";
import TenantListPage from "../pages/admin/tenantlistpage";
import TenantCreatePage from "../pages/admin/tenantcreatepage";
import TenantDetailPage from "../pages/admin/tenantdetailpage";
import TenantOnboardingPage from "../pages/admin/tenantonboardingpage";
import TenantProfilesListPage from "../pages/admin/tenantprofileslistpage";
import ServiceListPage from "../pages/admin/servicelistpage";
import AuditLogsPage from "../pages/admin/auditlogspage";
import OnboardingListPage from "../pages/admin/onboardinglistpage";
import AdminLayout from "../components/admin/AdminLayout";
import ErrorPage from "../pages/ErrorPage";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import TermsOfService from "../pages/TermsOfService";
import DataDeletion from "../pages/DataDeletion";
import PublicTenantProfile from "../pages/PublicTenantProfile";
import PublicTenantDirectory from "../pages/PublicTenantDirectory";

import ChatbotClientsPage from "../pages/admin/chatbot/ChatbotClientsPage";
import ChatbotClientCreatePage from "../pages/admin/chatbot/ChatbotClientCreatePage";
import ChatbotClientUsersPage from "../pages/admin/chatbot/ChatbotClientUsersPage";
import ChatbotClientUserCreatePage from "../pages/admin/chatbot/ChatbotClientUserCreatePage";
import ChatbotClientUserEditPage from "../pages/admin/chatbot/ChatbotClientUserEditPage";
import ChatbotClientDetailPage from "../pages/admin/chatbot/ChatbotClientDetailPage";
import ChatbotBusinessDetailPage from "../pages/admin/chatbot/ChatbotBusinessDetailPage";
import ChatbotToolsPage from "../pages/admin/chatbot/ChatbotToolsPage";
import ChatbotToolEditorPage from "../pages/admin/chatbot/ChatbotToolEditorPage";

const adminRoute = (element) => <PrivateRoute element={<AdminLayout>{element}</AdminLayout>} />;
const router = createBrowserRouter([
  {
    element: <WithHeaderLayout />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: AI_PDF_CONST.ROUTE.DOCUMENTS,
        element: <PrivateRoute element={<UploadDocuments />} />,
      },
      {
        path: AI_PDF_CONST.ROUTE.DOCUMENT_VIEW,
        element: <PrivateRoute element={<DocumentView />} />,
      },
      {
        path: AI_PDF_CONST.ROUTE.ADMIN_DASHBOARD,
        element: adminRoute(<AdminDashboardPage />),
      },
      {
        path: AI_PDF_CONST.ROUTE.ADMIN_TENANTS,
        element: adminRoute(<TenantListPage />),
      },
      {
        path: AI_PDF_CONST.ROUTE.ADMIN_TENANTS_CREATE,
        element: adminRoute(<TenantCreatePage />),
      },
      {
        path: AI_PDF_CONST.ROUTE.ADMIN_TENANT_DETAIL,
        element: adminRoute(<TenantDetailPage />),
      },
      {
        path: AI_PDF_CONST.ROUTE.ADMIN_TENANT_DETAIL + "/meta-config",
        element: adminRoute(<TenantDetailPage />),
      },
      {
        path: AI_PDF_CONST.ROUTE.ADMIN_TENANT_ONBOARDING,
        element: adminRoute(<TenantOnboardingPage />),
      },
      {
        path: AI_PDF_CONST.ROUTE.ADMIN_TENANT_PROFILES,
        element: adminRoute(<TenantProfilesListPage />),
      },
      {
        path: AI_PDF_CONST.ROUTE.ADMIN_SERVICES,
        element: adminRoute(<ServiceListPage />),
      },
      {
        path: AI_PDF_CONST.ROUTE.ADMIN_AUDIT_LOGS,
        element: adminRoute(<AuditLogsPage />),
      },
      {
        path: AI_PDF_CONST.ROUTE.ADMIN_ONBOARDING,
        element: adminRoute(<OnboardingListPage />),
      },
      {
        path: AI_PDF_CONST.ROUTE.HOLIOS,
        element: <Holios />,
      },
      {
        path: AI_PDF_CONST.ROUTE.HOLIOS_UPLOAD_DATA,
        element: <HoliosUploadData />,
      },
      {
        path: AI_PDF_CONST.ROUTE.AI_AUTOMATION,
        element: <AIAutomation />,
      },
      {
        path: AI_PDF_CONST.ROUTE.AI,
        element: <AiLanding />,
      },
      {
        path: AI_PDF_CONST.ROUTE.AI_A,
        element: <AIAutomationOptionA />,
      },
      {
        path: AI_PDF_CONST.ROUTE.AI_B,
        element: <AIAutomationOptionB />,
      },
      {
        path: AI_PDF_CONST.ROUTE.AI_AUTOMATION_2,
        element: <AIAutomation2 />,
      },
      {
        path: AI_PDF_CONST.ROUTE.COMMUNICATION,
        element: <Communication />,
      },
      {
        path: AI_PDF_CONST.ROUTE.AI_COMM,
        element: <AiComm />,
      },
      {
        path: AI_PDF_CONST.ROUTE.PDF_TO_EXL,
        element: <PdfToExl />,
      },
      {
        path: AI_PDF_CONST.ROUTE.VOICE_CALL,
        element: <PrivateRoute element={<VoiceCall />} />,
      },
      {
        path: "/chat",
        element: <Chat />,
      },
      {
        path: "/whatsapp-inbox/:tenantId?/:conversationId?",
        element: <PrivateRoute element={<CentralWhatsAppInbox />} />,
      },
      {
        path: AI_PDF_CONST.ROUTE.ADMIN_ORGS,
        element: <PrivateRoute element={<AdminOrgsPage />} />,
      },
      {
        path: AI_PDF_CONST.ROUTE.ADMIN_ORG_USERS,
        element: <PrivateRoute element={<AdminOrgUsersPage />} />,
      },
      
      {
        path: "/clients",
        element: adminRoute(<ChatbotClientsPage />),
      },
      {
        path: "/clients/new-client",
        element: adminRoute(<ChatbotClientCreatePage />),
      },
      {
        path: "/clients/:clientId/users/new-user",
        element: adminRoute(<ChatbotClientUserCreatePage />),
      },
      {
        path: "/clients/:clientId/users/:userId/edit",
        element: adminRoute(<ChatbotClientUserEditPage />),
      },
      {
        path: "/clients/:clientId/users",
        element: adminRoute(<ChatbotClientUsersPage />),
      },
      {
        path: "/clients/:clientId/tools",
        element: adminRoute(<ChatbotToolsPage />),
      },
      {
        path: "/clients/:clientId/tools/new",
        element: adminRoute(<ChatbotToolEditorPage />),
      },
      {
        path: "/clients/:clientId/tools/:toolId",
        element: adminRoute(<ChatbotToolEditorPage />),
      },
      {
        path: "/clients/:clientId",
        element: adminRoute(<ChatbotClientDetailPage />),
      },
      {
        path: "/clients/:clientId/new-bot",
        element: adminRoute(<ChatbotClientDetailPage />),
      },
      {
        path: "/bot/:businessId/bot-config",
        element: adminRoute(<ChatbotBusinessDetailPage />),
      },
      { path: "/privacy", element: <PrivacyPolicy /> },
      { path: "/terms", element: <TermsOfService /> },
      { path: "/data-deletion", element: <DataDeletion /> },
    ],
  },
  {
    element: <WithoutHeaderLayout />,
    errorElement: <ErrorPage />,
    children: [
      { path: AI_PDF_CONST.ROUTE.ROOT, element: <HomeComponent /> },
      { path: AI_PDF_CONST.ROUTE.HOME, element: <HomeComponent /> },
      { path: AI_PDF_CONST.ROUTE.HOME2, element: <HomeComponent2 /> },
      { path: AI_PDF_CONST.ROUTE.LOGIN, element: <Login /> },
      { path: AI_PDF_CONST.ROUTE.PUBLIC_TENANT_PROFILE, element: <PublicTenantProfile /> },
      { path: AI_PDF_CONST.ROUTE.PUBLIC_TENANT_DIRECTORY, element: <PublicTenantDirectory /> },
    ],
  },
]);

export default router;
